import { render, staticRenderFns } from "./Bypurchase.vue?vue&type=template&id=aad8d076&"
import script from "./Bypurchase.vue?vue&type=script&lang=js&"
export * from "./Bypurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports